module.exports = ".example-radio-group {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.example-radio-button {\n  margin: 5px; }\n\n.example-selected-value {\n  margin: 15px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/dictionary/university/edit/edit-center-college.component.scss
// module id = ./src/app/modules/user/components/dictionary/university/edit/edit-center-college.component.scss
// module chunks = main